// src/analytics/ga4.js
import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID, {  
    debug_mode: true, 
  });
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};

export const logEvent = (eventName, params = {}) => {
  if (eventName) {
    ReactGA.event(eventName, params);
  }
};


